<template>
  <div>
    <sui-page-tab-headless
      v-show="!isMain"
      ref="detailTab"
      :tabItems="tabItems"
      :defaultTabIndex="defaultTabIndex"
      :setCurrentTabComponent="setCurrentTabComponent"
    >
      <container
        :is="currentTabComponent"
        ref="container"
        :companyId="selectedCompanyId"
        :targetPageId="targetPageId"
        :siteList="codes.siteList"
        :taskList="codes.COD_COMP_RLTD_TASK_DIV"
        @mainViewLoad="mainViewLoad"
        @goDetailPage="goDetailPage"
        @page-deactivate="handleChildDeactivated"
        @page-activate="handleChildActivated"
      />
    </sui-page-tab-headless>

    <sui-page v-show="isMain">
      <sui-page-header :pageId="this.$options.name" />
      <sui-page-contents>
        <div class="comm_scr_wrap">
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_SITE')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <cmp-site-select
                ref="selectSite"
                :pageId="this.$options.name"
                :selected="searchFrame.selectedCodeValue.searchSiteId"
                :defaultOption="'all'"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_GEHS_COMP_ID')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model.trim="searchFrame.companyId"
                :disabled="false"
                :readonly="false"
                maxlength="50"
                @keyup.enter="onSearchClick"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_CONN_COMP_CD')"
                :required="false"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model.trim="searchFrame.connectionCompanyNumber"
                :disabled="false"
                :readonly="false"
                maxlength="50"
                @keyup.enter="onSearchClick"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_CORP_DSTG_NO')"
                :required="false"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model.trim="searchFrame.corpRegNumber"
                maxlength="50"
                :disabled="false"
                :readonly="false"
                @keyup.enter="onSearchClick"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_COMP_LCL_NM')"
                :required="false"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model.trim="searchFrame.companyName"
                maxlength="50"
                :disabled="false"
                :readonly="false"
                @keyup.enter="onSearchClick"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_COMP_GLBL_NM')"
                :required="false"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model.trim="searchFrame.companyGlobalName"
                maxlength="50"
                :disabled="false"
                :readonly="false"
                @keyup.enter="onSearchClick"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_ERP_COMP_CD')"
                :required="false"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model.trim="searchFrame.gerpCompanyNumber"
                maxlength="50"
                :disabled="false"
                :readonly="false"
                @keyup.enter="onSearchClick"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_RLTD_TASK')"
                :required="false"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-code-select
                ref="selectTask"
                :selected="searchFrame.selectedCodeValue.searchTaskDivCode"
                :pageId="this.$options.name"
                :defaultOption="'all'"
                codeId="COD_COMP_RLTD_TASK_DIV"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_REG_STATUS')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-code-select
                ref="selectRegState"
                :selected="searchFrame.selectedCodeValue.companyRegistrationStateCode"
                :pageId="this.$options.name"
                :defaultOption="'all'"
                codeId="COD_COMP_RGST_STT"
              />
            </div>
          </div><div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_MDFC_USR')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <cmp-user-select
                ref="userSelect"
                :selectedUser="selectedUser"
                @selected="userSelect"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_MDFC_DT')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-range-date-picker
                ref="datePicker"
                :value="searchFrame.rangeDate"
                :hideInput="false"
                sticky
                @confirm="onRangeConfirm"
              />
            </div>
            <div class="col-xs-1 nodata" />
            <div class="col-xs-3" />
          </div>
          <div class="btn_wrap">
            <sui-button
              v-permission:read="this.$options.name"
              type="button"
              class="comm_btn_Reset"
              @click="onResetClick"
            >
              {{ $t('MSG_BTN_RESET') }}
            </sui-button>
            <sui-button
              v-permission:read="this.$options.name"
              type="button"
              class="comm_btn_Scr"
              @click="onSearchClick"
            >
              {{ $t('MSG_BTN_SEARCH') }}
            </sui-button>
          </div>
        </div>
        <div class="mrB30" />
        <sui-grid
          ref="mainGrid"
          :columns="gridColumns0"
          :dataset="'ds0'"
          :showDisplayCountControl="false"
          :initial-pagesize="10"
        >
          <div class="btn_wrapR">
            <sui-button
              v-permission:download="this.$options.name"
              type="button"
              class="comm_btn_gridTop comm_ico_excel"
              @click="onExcelDownloadClick"
            >
              {{ $t('MSG_BTN_EXCEL_DOWN') }}
            </sui-button>
          </div>
        </sui-grid>
      </sui-page-contents>
    </sui-page>
  </div>
</template>
<script>
import BasePage from '~cm/components/BasePage';

const PGE_CMY_00012 = utils.getPageComponentById('PGE_CMY_00012');
const PGE_CMY_00013 = utils.getPageComponentById('PGE_CMY_00013');

export default {
  name: 'PGE_CMY_00010', // eslint-disable-line vue/name-property-casing
  components: {
    PGE_CMY_00012,
    PGE_CMY_00013,
  },
  extends: BasePage,
  data() {
    return {
      isMain: true,
      defaultTabIndex: 0,
      tabItems: [{
        tabTitle: 'PGE_CMY_00012',
        tabSubTitle: 'PGE_CMY_00012',
        component: 'PGE_CMY_00012',
      }, {
        tabTitle: 'PGE_CMY_00013',
        tabSubTitle: 'PGE_CMY_00013',
        component: 'PGE_CMY_00013',
      }],
      currentTabComponent: null,
      tabIndex: 0,
      codes: {
        siteList: [],
        COD_COMP_RLTD_TASK_DIV: [],
      },
      searchFrame: {
        selectedCodeValue: {
          searchSiteId: {
            key: '',
            label: '',
          },
          searchTaskDivCode: {
            key: '',
            label: '',
          },
          companyRegistrationStateCode: {
            key: '',
            label: '',
          },
        },
        companyId: '',
        connectionCompanyNumber: '',
        gerpCompanyNumber: '',
        corpRegNumber: '',
        companyName: '',
        companyGlobalName: '',
        finalModificationUserId: '',
        finalModificationStartDTM: '',
        finalModificationEndDTM: '',
        rangeDate: {
          from: null,
          to: null,
        },
      },
      selectedUser: {
        epId: '',
        siteName: '',
        employeeIDNumber: '',
        userName: '',
        companyName: '',
        departmentName: '',
        knoxId: '',
        servedStateCode: '',
        userId: '',
        epid: '',
        email: '',
      },
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_GEHS_COMP_ID'),
        datafield: 'companyId',
        width: '150px',
      }, {
        text: this.$t('MSG_TXT_ERP_COMP_CD'),
        datafield: 'gerpCompanyNumber',
      }, {
        text: this.$t('MSG_TXT_CONN_COMP_CD'),
        datafield: 'connectionCompanyNumber',
      }, {
        text: this.$t('MSG_TXT_CORP_DSTG_NO'),
        datafield: 'corpRegNumber',
      }, {
        text: this.$t('MSG_TXT_COMP_LCL_NM'),
        datafield: 'companyName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onGridSingleButtonClicked,
            type: 'link',
          }, this.ds0, this.$refs.mainGrid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_COMP_GLBL_NM'),
        datafield: 'companyGlobalName',
      }, {
        text: this.$t('MSG_TXT_REG_STATUS'),
        datafield: 'companyRegistrationStateName',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_MDFC_USR'),
        datafield: 'userNameAndId',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1',
            type: 'link',
            datafieldMap: {
              displayLanguageId: 'dsplLngId',
              knoxId: 'knoxId',
              userName: 'userName',
              userGlobalName: 'userGlobalName',
              departmentName: 'departmentName',
              departmentEnglishName: 'departmentEnglishName',
            },
          }, this.ds0, this.$refs.mainGrid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: '200px',
      }, {
        text: this.$t('MSG_TXT_MDFC_DT'),
        datafield: 'finalModificationDTM',
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, { formatOption: 'S' }, this.ds0, this.$refs.mainGrid),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),
        width: '100px',
      }],
      selectedCompanyId: '',
      targetPageId: '',
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'ds0',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'finalModificationDTM', map: 'finalModificationDTM' },
      { type: 'string', name: 'finalModificationUserId', map: 'finalModificationUserId' },
      { type: 'string', name: 'companyId', map: 'companyId' },
      { type: 'string', name: 'companyName', map: 'companyName' },
      { type: 'string', name: 'companyGlobalName', map: 'companyGlobalName' },
      { type: 'string', name: 'bizDivisionCode', map: 'bizDivisionCode' },
      { type: 'string', name: 'corpRegNumber', map: 'corpRegNumber' },
      { type: 'string', name: 'corpBizNumber', map: 'corpBizNumber' },
      { type: 'string', name: 'companyRepresentativeName', map: 'companyRepresentativeName' },
      { type: 'string', name: 'companyRepresentativeTelNumber', map: 'companyRepresentativeTelNumber' },
      { type: 'string', name: 'companyEstablishDTM', map: 'companyEstablishDTM' },
      { type: 'string', name: 'companyFaxNumber', map: 'companyFaxNumber' },
      { type: 'string', name: 'companyZipCode', map: 'companyZipCode' },
      { type: 'string', name: 'companyAddress', map: 'companyAddress' },
      { type: 'string', name: 'companyRepresentativeEmail', map: 'companyRepresentativeEmail' },
      { type: 'string', name: 'bizTypeName', map: 'bizTypeName' },
      { type: 'string', name: 'bizConditionsName', map: 'bizConditionsName' },
      { type: 'string', name: 'nationCode', map: 'nationCode' },
      { type: 'string', name: 'nationName', map: 'nationName' },
      { type: 'string', name: 'affiliatedCompanyDivisionCode', map: 'affiliatedCompanyDivisionCode' },
      { type: 'string', name: 'companyHomepageYn', map: 'companyHomepageYn' },
      { type: 'string', name: 'companyHomepageUrl', map: 'companyHomepageUrl' },
      { type: 'string', name: 'companyEmpValue', map: 'companyEmpValue' },
      { type: 'string', name: 'companyScaleCode', map: 'companyScaleCode' },
      { type: 'string', name: 'companyScaleValue', map: 'companyScaleValue' },
      { type: 'string', name: 'gerpCompanyNumber', map: 'gerpCompanyNumber' },
      { type: 'string', name: 'connectionCompanyNumber', map: 'connectionCompanyNumber' },
      { type: 'string', name: 'companyAccountGroupCode', map: 'companyAccountGroupCode' },
      { type: 'string', name: 'companyAccountGroupName', map: 'companyAccountGroupName' },
      { type: 'string', name: 'companyCloseAccountsDTM', map: 'companyCloseAccountsDTM' },
      { type: 'string', name: 'companyCapitalAmount', map: 'companyCapitalAmount' },
      { type: 'string', name: 'companyCapitalSumAmount', map: 'companyCapitalSumAmount' },
      { type: 'string', name: 'companyDebtSumAmount', map: 'companyDebtSumAmount' },
      { type: 'string', name: 'companyDebtRatioValue', map: 'companyDebtRatioValue' },
      { type: 'string', name: 'companyCapitalSurplusAmount', map: 'companyCapitalSurplusAmount' },
      { type: 'string', name: 'companyTradePossibilityYn', map: 'companyTradePossibilityYn' },
      { type: 'string', name: 'companyRegistrationStateCode', map: 'companyRegistrationStateCode' },
      { type: 'string', name: 'companyRegistrationStateName', map: 'companyRegistrationStateName' },
      { type: 'string', name: 'companyUseYn', map: 'companyUseYn' },
      { type: 'string', name: 'companyRegistrationApprovalId', map: 'companyRegistrationApprovalId' },
      { type: 'string', name: 'vendorTaskSiteList', map: 'vendorTaskSiteList' },
      { type: 'string', name: 'vendorCategoryList', map: 'vendorCategoryList' },
      { type: 'string', name: 'vendorCreditEvaluationList', map: 'vendorCreditEvaluationList' },
      { type: 'string', name: 'finalModificationStartDTM', map: 'finalModificationStartDTM' },
      { type: 'string', name: 'finalModificationEndDTM', map: 'finalModificationEndDTM' },
      { type: 'string', name: 'dsplLngId', map: 'dsplLngId' },
      { type: 'string', name: 'knoxId', map: 'knoxId' },
      { type: 'string', name: 'userName', map: 'userName' },
      { type: 'string', name: 'userGlobalName', map: 'userGlobalName' },
      { type: 'string', name: 'departmentName', map: 'departmentName' },
      { type: 'string', name: 'departmentEnglishName', map: 'departmentEnglishName' },
      { type: 'string', name: 'userNameAndId', map: 'userNameAndId' },
    ],
  }],
  mounted() {
    this.$nextTick(() => {
      this.selectListLoad();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    selectListLoad() {
      this.siteListLoad();
      this.taskListLoad();
    },
    siteListLoad() {
      http.request(this.$options.name, 'DTS_CMZ_00074', {
        query: { applyAuthorityYn: 'N' },
      }).then(res => {
        res.data.forEach(site => {
          this.codes.siteList.push({
            key: site.siteId,
            label: site.siteAbbreviationName,
          });
        });
      }).catch(error => {
        console.log(error);
      });
    },
    taskListLoad() {
      return http.mergeCodeList(this.$options.name, ['COD_COMP_RLTD_TASK_DIV'], this.codes).then(() => {
      }).catch(error => {
        console.log(error);
      });
    },
    // -----------------------------------------------------------------------------------
    onResetClick() {
      utils.forEach(this.searchFrame, (value, key) => {
        if (utils.isEqual(key, 'selectedCodeValue')) {
          this.$refs.selectSite.select(this.$store.getters.userInfo.siteId);
          this.$refs.selectTask.reset();
          this.$refs.selectRegState.reset();
        } else if (utils.isEqual(key, 'rangeDate')) {
          this.searchFrame.rangeDate = { from: null, to: null };
        } else {
          this.searchFrame[key] = '';
        }
      });
      this.userSelectReset();
    },
    onRangeConfirm(value) {
      this.searchFrame.rangeDate = utils.assign(value);
    },
    userSelect(selected) {
      if (utils.isEmpty(selected)) {
        this.searchFrame.finalModificationUserId = '';
      } else {
        this.searchFrame.finalModificationUserId = selected.userId;
      }
    },
    userSelectReset() {
      utils.forEach(this.selectedUser, (value, key) => {
        this.selectedUser[key] = '';
      });
      this.$refs.userSelect.setValue(this.selectedUser);
    },
    getSearchData() {
      const data = {};
      utils.forEach(this.searchFrame, (value, key) => {
        if (utils.isEqual(key, 'selectedCodeValue')) {
          utils.forEach(value, (codeValue, codekey) => {
            data[codekey] = codeValue.key;
          });
        } else if (utils.isEqual(key, 'rangeDate')) {
          utils.assign(data, {
            finalModificationStartDTM: utils.isEmpty(value.from) ? '' : utils.dateformatToServer(value.from),
            finalModificationEndDTM: utils.isEmpty(value.to)
              ? ''
              : utils.dateformatToServer(value.to, 'S').concat('235959'),
          });
        } else {
          data[key] = value;
        }
      });
      return data;
    },
    onSearchClick() {
      if (this.onClickValidate()) return false;

      const searchData = this.getSearchData();
      http.request(this.$options.name, 'DTS_CMY_00015', {
        query: searchData,
      }).then(res => {
        utils.forEach(res.data, data => {
          const userInfo = data.finalModificationUserInfo;
          if (!utils.isEmpty(userInfo)) {
            utils.assign(data, userInfo);
            utils.set(data, 'userNameAndId', `${userInfo.userName} / ${userInfo.knoxId}`);
          }
        });
        this.ds0.setRawData(res.data);
      }).catch(error => {
        console.log(error);
      });

      return null;
    },
    onGridSingleButtonClicked(value, dataRow) {
      const { companyId, connectionCompanyNumber, companyRegistrationStateCode } = dataRow;
      // 상생업체 정보 선택 여부 -- 선택 시 true
      const connectionCompanyFlag = !utils.isEmpty(connectionCompanyNumber);
      // 등록상태 -- 등록완료 시 true
      const companyRegistrationStateFlag = utils.isEqual(companyRegistrationStateCode, '6');
      const index = companyRegistrationStateFlag && !connectionCompanyFlag ? 1 : 0;
      this.goPageComponentTab(companyId, index);
    },
    goDetailPage(data) {
      this.goPageComponentTab(data.companyId, data.index);
    },
    goPageComponentTab(companyId, index) {
      this.selectedCompanyId = companyId;
      this.targetPageId = this.tabItems[index].component;
      // this.$refs.detailTab.$children[index].$children[0].$children[1].$el.scrollTop = 0;
      this.isMain = false;
      this.$refs.detailTab.changeIdx(index);
    },
    onExcelDownloadClick() {
      const sToday = utils.now('YYYYMMDDHHmmss');
      const sExcelName = `vendorList_${sToday}.xlsx`;
      utils.downloadGridToExcel(this.$options.name, this.gridColumns0, this.ds0, sExcelName);
    },
    mainViewLoad() {
      this.selectedCompanyId = '';
      this.targetPageId = '';
      this.isMain = true;
    },
    setCurrentTabComponent(component) {
      this.currentTabComponent = component;
    },
    /* 달력의 오류를 확인할 수 있는 validate 함수 */
    onClickValidate() {
      // if (this.onClickValidate()) return false;
      if (!this.$refs.datePicker.isValid()) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
        return true;
      }
      return false;
    },
  },
};
</script>
<style scoped>
</style>
